export default __webpack_public_path__ + "90d0989.png";